"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileEditPhone = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var kapi_1 = require("../../../../shared/api/kapi");
var core_1 = require("../../../../shared/core");
var with_customer_and_account_ids_1 = require("../../../../shared/core/utils/with-customer-and-account-ids");
var analytics_subjects_1 = require("../../analytics-subjects");
var data_1 = require("../../data");
var mapping_1 = require("../../data/mapping");
var ui_1 = require("./ui");
exports.ProfileEditPhone = (0, with_customer_and_account_ids_1.withCustomerAndAccountIds)(function (_a) {
    var _b;
    var customerId = _a.customerId, accountId = _a.accountId;
    var _c = (0, kapi_1.useProfileQuery)({
        variables: {
            customerId: customerId,
            accountId: accountId,
        },
    }), data = _c.data, loading = _c.loading, error = _c.error;
    var profileCX = (0, mapping_1.mapProfileQueryKapiToProfileCX)(data);
    var _d = (0, data_1.useUpdateProfile)({
        customerId: customerId,
        accountId: accountId,
    }), mutate = _d.mutate, mutationLoading = _d.loading;
    return (react_1.default.createElement(ui_tools_1.AnalyticsPage, { name: analytics_subjects_1.PROFILE_EDIT_EMAIL, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) }, loading ? (react_1.default.createElement(ui_1.Loading, null)) : error || !profileCX ? (react_1.default.createElement(ui_1.Error, null)) : (react_1.default.createElement(ui_1.ProfileEditPhoneUI, { profile: profileCX, mutationLoading: mutationLoading, mutate: mutate }))));
}, ui_1.Loading);
